<template>
  <div class="app-loading" :style="{ padding: padding }">
    <svg
        class="app-loading__ring"
        :width="size"
        :height="size"
        viewBox="0 0 56 56"
        fill="none"
    >
      <defs>
        <linearGradient :id="gradientId" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" :stop-color="colorLight" />
          <stop offset="100%" :stop-color="colorBase" />
        </linearGradient>
      </defs>

      <!-- trilha fixa -->
      <circle
          cx="28"
          cy="28"
          r="24"
          :stroke="trackColor"
          stroke-width="4"
          fill="none"
      />

      <!-- arco girando -->
      <circle
          cx="28"
          cy="28"
          r="24"
          :stroke="`url(#${gradientId})`"
          stroke-width="4"
          fill="none"
          stroke-linecap="round"
          stroke-dasharray="113"
          stroke-dashoffset="85"
          class="app-loading__arc"
      />
    </svg>

    <span v-if="text" class="app-loading__text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    text: {
      type: String,
      default: "",
    },
    size: {
      type: [Number, String],
      default: 52,
    },
    padding: {
      type: String,
      default: "32px 0",
    },
    colorBase: {
      type: String,
      default: "#1976D2", // igual ao color="primary" do Vuetify usado no resto do app
    },
    colorLight: {
      type: String,
      default: "#64B5F6",
    },
    trackColor: {
      type: String,
      default: "#E3EDF7",
    },
  },
  computed: {
    gradientId() {
      // evita conflito quando existe mais de um spinner na mesma página
      return `app-loading-gradient-${this._uid}`;
    },
  },
};
</script>

<style scoped>
.app-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.app-loading__arc {
  transform-origin: 28px 28px;
  animation: app-loading-spin 0.9s linear infinite;
}

.app-loading__text {
  margin-top: 14px;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 0.01em;
}

@keyframes app-loading-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* acessibilidade: quem pede menos movimento não recebe giro contínuo */
@media (prefers-reduced-motion: reduce) {
  .app-loading__arc {
    animation: none;
  }
}
</style>
